import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const ToolAccuracyGraph = ({
  suspicious = [],
  scrap = [],
  good = [],
  categories = [],
}) => {
  const [state, setState] = useState({
    chart: {
      type: "column",
      height: "230px",
      toolbar: {
        show: false,
      },
      backgroundColor: "transparent",
      plotBackgroundColor: "#3C3A77",
      plotBorderWidth: 2,
      plotBorderColor: "#645E86",
      plotBorderRadius: 20,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        return `${this.series.name}: <b>${this.y
          .toString()
          .replace(/\s+/g, "")}</b>`;
      },
    },
    title: {
      text: "Production Summary",
      align: "left",
      style: {
        color: "#D2D2EA",
        fontSize: "13px",
        fontWeight: "500",
      },
      floating: true,
    },
  });

  useEffect(() => {
    setState((prevOptions) => ({
      ...prevOptions,
      xAxis: {
        categories: categories,
        labels: {
          show: true,
          rotation: -20,
          style: {
            color: "#D2D2EA",
            fontSize: "10px",
            fontWeight: "600",
          },
        },
        // lineWidth: 0,
      },
      yAxis: [
        {
          seriesName: "Suspicious",
          title: "",
          // opposite: true,
          tickAmount: 5,
          labels: {
            format: "{text}",
            style: {
              color: "#D2D2EA",
              fontSize: "10px",
              fontWeight: "600",
            },
          },
        },
        {
          seriesName: "scrap",
          title: "",
          tickAmount: 5,
          labels: {
            enabled: false,
          },
        },
      ],
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      legend: {
        align: "right",
        verticalAlign: "top",
        alignColumns: false,
        itemStyle: {
          fontSize: "11px",
          fontWeight: "600",
          color: "#D2D2EA",
        },
        symbolPadding: 0,
        symbolRadius: 2,
      },
      series: [
        {
          name: "Actual Good Parts",
          data: good,
          color: "#34A853",
        },
        {
          name: "Suspicious Parts",
          data: suspicious,
          color: "#EA8600",
        },
        {
          name: "Actual Scrap Parts",
          data: scrap,
          color: "#EA4335",
        },
      ],
    }));
  }, [suspicious, scrap, categories]);

  return (
    <div id="chart">
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};

export default ToolAccuracyGraph;
